import { graphql } from 'react-relay';
export const HomeRecentCreatedQuery = graphql`
	query HomeRecentCreatedQuery($cql: String!, $cqlcontext: String!, $first: Int, $after: String) {
		search: confluence_search(cql: $cql, cqlcontext: $cqlcontext, first: $first, after: $after) {
			nodes {
				content {
					id
					title
					type
					subType
					links {
						webui
						editui
					}
					excerpt(length: 372)
					metadata {
						currentuser {
							favourited {
								isFavourite
							}
						}
						comments {
							commentsCount
						}
					}
					space {
						alias
						id
						key
						name
					}
					likes {
						count
					}
					status
					blank
					metadata {
						createdDate
					}
					editorVersion: properties(key: "editor") {
						nodes {
							id
							key
							value
						}
					}
					emoji: properties(keys: ["emoji-title-published"]) {
						nodes {
							id
							value
							key
						}
					}
					history {
						createdBy {
							... on KnownUser {
								accountId
							}
						}
					}
					version {
						by {
							... on KnownUser {
								accountId
							}
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
